import React from 'react';
import * as Sentry from '@sentry/react';
import { GenericErrorPage } from './GenericErrorPage';

interface Props {
  children: React.ReactNode;
  userId: string;
}

export function ErrorBoundary({ children, userId }: Props) {
  React.useEffect(() => {
    Sentry.setUser({ id: userId });
  }, [userId]);

  return (
    <Sentry.ErrorBoundary fallback={<GenericErrorPage />} handled={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default ErrorBoundary;
